import React, { Component, createRef } from "react";
import { io } from "socket.io-client";
import Button from "react-bootstrap/Button";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  addAreaCodeFirstTimeProjectVise,
  getChecks,
  getQueueItems,
  loadImage,
} from "../../../common/services/uiService";
import SearchTamarForm from "../../../common/components/forms/searchTamarForm";
import { getSessionId } from "../../../common/services/browserSessionID";
import ModalComponent from "./../../../common/components/modal/modalComponent";
import { cancelQueueProcessCancel } from "../../../common/services/generalService";
import ProcessCard from "./../../../common/components/processCard";
import SideMenuContext from "./../../../common/context/sideMenuContext";
import {
  calculateProgressState,
  checkWiseData,
  mergeDWGfiles,
  getCalculatedCompleted,
  getCalculatedSeverities,
  getCalculatedRandomErrors,
  getCalculatedNoErrors,
  getSeveritiesTypes,
  isActiveToContinue,
  hasCriticalFailures,
} from "../../../common/services/helper";
import ProcessContext from "../../../common/context/processContext";
import { clearAllErrors } from "./../../../common/redux/slices/landSearchSlice";
//import "./../../styles/LoadTamar.css";

class LoadTamar extends Component {
  constructor(props) {
    // localStorage.clear();
    localStorage.removeItem("loglevel");
    super(props);
    this.allQueuesItemProcessed = this.allQueuesItemProcessed.bind(this);
    this.searchTamarFormRef = createRef(); // Create a reference to SearchTamarForm
    this.generalEndPoint = props.generalEndPoint;
  }

  // Define ProcessContext for use in the class
  static contextType = ProcessContext;

  state = {
    D2_checksList: [],
    D3_checksList: [],
    D3_advanced: [],
    D3_cmp: [],
    isModalOpen: false,
    fileName: "",
    isProcessCancelModal: false,
    isFileSelected: false,
    currentSessionIdForCancelEvent: "",
    processes: [],
    selectedRuns: "D2_D3_ALL",
    uploadProgress: 0,
    selectedD2Checks: [],
    selectedD3Checks: [],
    pendingProcessesState: [],
    processIsCanceled: false,
    loading: false,
    RandomError: false,
    randomErrorDismissedBatchIDs: [],
    randomErrorPopupBatchID: null,
    processStatus: ["InProgress", "Canceled", "Processed", "Pending"],
    registrationNumber: "",
    existFileGUID: "",
    RunningD4: false,
    gushNumber: null,
    processName: null,
    batchIDList: [],
    isD4ConfirmationModal: false,
    //browserSessionID: getSessionId()  // Load or initialize sessionID
  };

  cancelRequestQueueProcess = () => {
    if (this.props.isDisabled) {
      this.setState({ isProcessCancelModal: true });
    } else {
      sessionStorage.setItem("sessionID", "");
      this.setState({
        isProcessCancelModal: false,
        browserSessionID: "",
      });
      this.props.isProcesssInQueue(false);
      this.props.stopAllRunningProcess("closeEvent");
      localStorage.clear();
      this.props.history.push("/home");
    }
  };

  setRunningD4 = (payload) => {
    this.setState({
      RunningD4: payload,
    });
  };
  setLoading = (payload) => {
    this.setState({
      loading: payload,
    });
  };
  setFileName = (payload) => {
    this.setState({
      fileName: payload,
    });
  };
  setExistFileGUID = (payload) => {
    this.setState({
      existFileGUID: payload,
    });
  };

  allQueuesItemProcessed(event) {
    this.props?.isProcesssInQueue(event);
  }

  handleOnChange = (payload) => {
    this.setState({ ...payload });
  };

  addInFirstObj = () => {
    const { pendingProcessesState } = this.state;
    this.setState({
      processIsCanceled: false,
      pendingProcessesState: [...pendingProcessesState, true],
    });
  };

  setSelectedRuns = (payload) => {
    this.setState({
      selectedRuns: payload,
    });
  };

  handleUploadProgress = (progress) => {
    this.setState({
      uploadProgress: progress,
    });
  };
  handleD4 = () => {
    const { processes, selectedRuns, fileName } = this.state;
    const lastObject = processes[0];
  
    // For "בדיקות מבוקרות בשלבים" (D2_ALL):
    // First click (after D2): Load D3 directly without any popup
    if (
      selectedRuns === "D2_ALL" &&
      lastObject?.["checkType"] === "D2" &&
      lastObject?.["selectedRuns"] === "D2_ALL" &&
      lastObject?.["fileName"] === fileName
    ) {
      // First click: Load D3 directly without showing any popup
      this.props?.isProcesssInQueue(true);
      this.setState({
        loading: true,
      });
      this.searchTamarFormRef?.current?.handleUploadFileD3();
      return;
    }
  
    // For "בדיקות מבוקרות בשלבים" (D2_ALL) after D3:
    // Show confirmation popup directly (skip critical warning)
    if (
      selectedRuns === "D2_ALL" &&
      lastObject?.["checkType"] === "D3"
    ) {
      this.setState({ isD4ConfirmationModal: true });
      return;
    }
  
  
    // For "בדיקות אוטומטיות מלאות" (D2_D3_ALL):
    // Check if there are Critical failures (but no Stop failures)
    if (hasCriticalFailures(processes)) {
      this.setState({ isCriticalWarningModal: true });
    } else {
      // No critical failures, proceed with normal D4 confirmation
      this.setState({ isD4ConfirmationModal: true });
    }
  };

  confirmAndExecuteD4 = () => {
    const { processes } = this.state;
  
    if (this.searchTamarFormRef.current) {
      this.props?.isProcesssInQueue(false);
      this.setState({ RunningD4: true });
      this.searchTamarFormRef?.current?.handleUploadFile(true); // Pass true for checkD4
    }
  };

  makeFetchCall = () => {
    const { browserSessionID } = this.state; // Retrieve the session ID from state
    const sessionId = browserSessionID?.replace(/['"]+/g, ""); // Remove any double quotes from the session ID
    this.setState({ currentSessionIdForCancelEvent: sessionId });

    getQueueItems(this.generalEndPoint, sessionId)
      .then((data) => {
        if (Array.isArray(data)) {
          data?.length > 0 && this.getBatchIDwiseData(data);
        }
      })
      .catch((error) => {
        console.error("Error fetching queue items:", error);
      });
  };

  fetchQueueItems = () => {
    // Properly get and set the session ID in the state if it isn't already set
    if (!this.state?.browserSessionID) {
      this.setState({ browserSessionID: getSessionId() }, () => {
        this.makeFetchCall();
      });
    } else {
      this.makeFetchCall();
    }
  };

  fetchCheckLists = async () => {
    let { D2_checksList, D3_checksList, D3_cmp, D3_advanced } = this.state;
    // Get Migration checks
    await getChecks(this.generalEndPoint, "Migration")
      .then((response) => {
        D2_checksList = response;
        this.setState({ D2_checksList });
      })
      .catch((error) => console.log(error));
    // Get D3 advanced checks
    await getChecks(this.generalEndPoint, "Advanced")
      .then((response) => {
        D3_advanced = response;
        this.setState({ D3_advanced });
      })
      .catch((error) => console.log(error));
    // Get D3 comparison checks
    await getChecks(this.generalEndPoint, "Comparison")
      .then((response) => {
        D3_cmp = response;
        this.setState({ D3_cmp });
      })
      .catch((error) => console.log(error));

    D3_checksList = D3_advanced.concat(D3_cmp);
    this.setState({ D3_checksList });
  };

  addBatch = (batchID, status) => {
    this.setState((prevState) => ({
      batchIDList: [...prevState.batchIDList, { batchID, status }],
    }));
  };

  getBatchStatus = (batchID) => {
    const batch = this.state.batchIDList.find(
      (item) => item.batchID === batchID
    );
    return batch ? batch.status : "Not Found";
  };

  updateBatchStatus = (batchID, newStatus) => {
    this.setState((prevState) => ({
      batchIDList: prevState.batchIDList.map((item) =>
        item.batchID === batchID ? { ...item, status: newStatus } : item
      ),
    }));
  };

  addProjectViseFirstTimeAddString = async (eclipsNumber) => {
    const result = await addAreaCodeFirstTimeProjectVise(
      this.generalEndPoint,
      this.props.extraParams.projectNumber,
      eclipsNumber
    );
    // const result = await addAreaCodeFirstTimeProjectVise('http://localhost:9001/api/generalservice', 1, eclipsNumber)
  };

  getBatchIDwiseData = async (data) => {
    let finalData = [];
    const {
      D2_checksList,
      D3_checksList,
      selectedRuns,
      processIsCanceled,
      processStatus,
      loading,
      fileName,
      RunningD4,
      batchIDList,
    } = this.state;
    // Access ProcessContext using 'this.context'
    const processContext = this.context;

    D2_checksList.map((element) => {
      element["checkType"] = "D2";
    });
    D3_checksList.map((element) => {
      element["checkType"] = "D3";
    });

    const date = new Date();

    const filteredData = data?.filter((d) => d?.["checkNumber"] !== "0");

    for (const checkData of filteredData) {
      const findIndex = finalData.findIndex(
        (fData) => fData?.["batchID"] === checkData?.["batchID"]
      );

      const checksList =
        checkData?.["checkType"] === "D2" ? D2_checksList : D3_checksList;

      const notProperStatus = !processStatus?.includes(checkData?.["status"]);

      const dataList = checkWiseData(filteredData, checkData?.["batchID"]);

      const calculateCompleted = getCalculatedCompleted(
        dataList,
        "Processed",
        checkData?.["batchID"]
      );

      const isSomeCanceled = filteredData?.some((item) => {
        return (
          checkData?.["batchID"] === item?.["batchID"] &&
          item?.["status"] === "Canceled"
        );
      });

      const { reportSeverity, criticalStopSeverity } = getSeveritiesTypes([
        ...D2_checksList,
        ...D3_checksList,
      ]);

      const isCriticalOrStop = !!criticalStopSeverity?.find(
        (severity) =>
          (severity?.["severity"] === "Stop" ||
            severity?.["severity"] === "Critical") &&
          severity?.["checkNo"] === checkData?.["checkNumber"]
      )?.["checkNo"];

      //let progress = calculateProgressState(calculateCompleted, dataList);
      const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      let progress;

      if (calculateCompleted.length !== dataList.length) {
        progress = calculateProgressState(calculateCompleted, dataList);
      }

      // let SomeErrorFound = dataList?.some((result) => {
      //   return (
      //     checkData?.["batchID"] === result?.["batchID"] &&
      //     result?.["result"].endsWith(".xlsx") &&
      //     result?.["status"] === "Processed"
      //   );
      // });

      let SomeErrorFound = dataList
        ?.filter((d) => d?.["checkNumber"] !== "0" && d?.["checkType"] !== "D7")
        .some((result) => {
          return (
            checkData?.["batchID"] === result?.["batchID"] &&
            result?.["result"] !== "No Error" &&
            result?.["status"] === "Processed"
          );
        });

      //Calculate severity counts early for use in validation and payload
      const calculateReportSeverity = getCalculatedSeverities(
        dataList,
        checksList,
        "Report"
      );

      const calculateCriticalSeverity = getCalculatedSeverities(
        dataList,
        checksList,
        "Critical"
      );

      const calculateStopSeverity = getCalculatedSeverities(
        dataList,
        checksList,
        "Stop"
      );

      const totalSeveritiesCount = 
        calculateReportSeverity.length + 
        calculateCriticalSeverity.length + 
        calculateStopSeverity.length;

      const calculateNoErrors = getCalculatedNoErrors(dataList);
      const calculateNoErrorsCount = calculateNoErrors.length;

      // Calculate random errors once when all checks are done - used for popup and merge decision
      const calculatedRandomErrors =
        calculateCompleted.length === dataList.length
          ? getCalculatedRandomErrors(
              dataList?.filter((d) => d?.["checkNumber"] !== "0"),
              checkData?.["batchID"]
            )
          : [];

      const isBatchDismissed = (this.state.randomErrorDismissedBatchIDs || []).includes(
        checkData?.["batchID"]
      );
      if (
        calculateCompleted.length === dataList.length &&
        calculatedRandomErrors.length > 0 &&
        !isBatchDismissed
      ) {
        this.setState({
          RandomError: true,
          randomErrorPopupBatchID: checkData?.["batchID"],
        });
      }

      //In case the run is done and there is some error -> Get all the dwg and excel files
      if (calculateCompleted.length === dataList.length && SomeErrorFound && (calculateNoErrorsCount + totalSeveritiesCount) === dataList.length) {
        //Get all the relevant checks results
        const lastObject = dataList?.filter(
          (d) =>
            d?.["checkNumber"] !== "0" &&
            d?.["checkType"] !== "D7" &&
            d?.["batchID"] === checkData?.["batchID"]
        )[0];
        const currentBatchID = lastObject?.["batchID"];
        const filteredData1 = dataList?.filter(
          (process) =>
            process?.checkNuber !== "0" &&
            process?.checkType !== "D4" &&
            process?.checkType !== "D7" &&
            process?.batchID === currentBatchID
        );

        //Get all the results with dwg result file
        const DWGFileIds = filteredData1
          ?.filter((process) => process.dwgFileID !== null)
          .map((process) => process.dwgFileID);

        //Get all the results with excel result file
        const ExcelFileIds = filteredData1
          ?.filter(
            (process) =>
              process.excelFileID !== null && process.excelFileID !== 0
          )
          .map((process) => process.excelFileID);
        const fileID = lastObject?.["fileID"];

        const projectID = this.props.extraParams?.["projectID"];
        if (
          ExcelFileIds.length >= DWGFileIds.length && ExcelFileIds.length === totalSeveritiesCount
        ) {
          console.log("Merging files for batchID:", currentBatchID);
          if (
            !this.state.batchIDList.some(
              (item) => item.batchID === checkData?.["batchID"]
            )
          ) {
            this.addBatch(checkData?.["batchID"], "Pending");

            // Only merge when no random errors (calculatedRandomErrors from above)
            if (calculatedRandomErrors.length === 0) {
              //If no inconsistent error -> Create the merged dwg file
              const result = await mergeDWGfiles(
                this.generalEndPoint,
                DWGFileIds,
                getSessionId(),
                currentBatchID,
                lastObject?.["batchName"],
                fileID,
                ExcelFileIds,
                projectID
              );

              //Wait for the merge result
              while (result === undefined) {
                await wait(10000);
              }

              //Recalculate the progress bar to update it to 100%
              this.updateBatchStatus(checkData?.["batchID"], "Completed");
              progress = calculateProgressState(calculateCompleted, dataList);
              checkData["progressStatus"] = progress;
            } else {
              // Random errors - don't merge, but update progress
              progress = calculateProgressState(calculateCompleted, dataList);
              checkData["progressStatus"] = progress;
            }
          } else {
            if (this.getBatchStatus(checkData?.["batchID"]) === "Completed") {
              progress = calculateProgressState(calculateCompleted, dataList);
              checkData["progressStatus"] = progress;
            }
          }
        }
      } else {
        progress = calculateProgressState(calculateCompleted, dataList);
        checkData["progressStatus"] = progress;
      }

      const selectedRunsForObj = processContext.processBackUp?.find(
        (selectedRun) => selectedRun?.["batchID"] === checkData?.["batchID"]
      );

      if (!selectedRunsForObj?.["batchID"]) {
        const payload = {
          batchID: checkData?.["batchID"],
          selectedRuns: selectedRuns,
          localStartTime: date,
          uploadProgress: this.state.uploadProgress,
          isSomeCanceled: isSomeCanceled,
          reportSeverity: calculateReportSeverity,
          criticalSeverity: calculateCriticalSeverity,
          stopSeverity: calculateStopSeverity,
          isCriticalOrStop: isCriticalOrStop,
          completedList: calculateCompleted,
          progressStatus: progress,
          isLastProcessEnd: progress === "100" ? true : false,
          fileName: fileName,
          notProperStatus: notProperStatus,
        };
        processContext.setProcessBackUp([
          ...processContext.processBackUp,
          payload,
        ]);
      } else {
        if (
          !selectedRunsForObj?.["processValue"]?.length &&
          !selectedRunsForObj?.["gushValue"]?.length
        ) {
          const findGushNumberObj = data?.find(
            (d) =>
              checkData?.["batchID"] === d?.["batchID"] &&
              d?.["checkNumber"] === "0"
          );
          const processAndGushNo =
            findGushNumberObj?.["result"]?.includes("VALUE_PROCESS_NAME") &&
            findGushNumberObj?.["result"]?.includes("VALUE_GUSH_NUM");

          if (processAndGushNo) {
            // "VALUE_PROCESS_NAME: 1045/2023, VALUE_GUSH_NUM: 30002"
            const [processName, gushNo] =
              findGushNumberObj?.["result"]?.split(", ");
            const [processLabel, processValue] = processName?.split(": ");
            const [gushLabel, gushValue] = gushNo?.split(": ");

            if (this.state.processName) {
              this.setState({ gushNumber: gushValue });
            } else {
              this.setState({
                gushNumber: gushValue,
                processName: processValue,
              });
            }

            this.addProjectViseFirstTimeAddString(processValue);
            const existingSelectedRunsFor = processContext.processBackUp;
            const findIndexSelectedFor = existingSelectedRunsFor?.findIndex(
              (selectedRun) =>
                selectedRun?.["batchID"] === selectedRunsForObj?.["batchID"]
            );

            const existingSelectedRunsObj =
              existingSelectedRunsFor?.[findIndexSelectedFor];

            existingSelectedRunsObj["gushValue"] = gushValue;
            existingSelectedRunsObj["processValue"] = processValue;
            processContext.setProcessBackUp([...existingSelectedRunsFor]);
          }
        }

        if (
          !selectedRunsForObj?.["localEndTime"] &&
          calculateCompleted?.length === dataList?.length &&
          !isSomeCanceled
        ) {
          selectedRunsForObj["localEndTime"] = date;
        }
      }

      if (findIndex > -1) {
        const existingResult = finalData[findIndex];

        const newDataList = checkWiseData(
          filteredData,
          existingResult?.["batchID"]
        );

        const existingCalculateReportSeverity = getCalculatedSeverities(
          newDataList,
          checksList,
          "Report"
        );

        const existingCalculateCriticalSeverity = getCalculatedSeverities(
          newDataList,
          checksList,
          "Critical"
        );

        const existingCalculateStopSeverity = getCalculatedSeverities(
          newDataList,
          checksList,
          "Stop"
        );

        existingResult["dataList"] = selectedRunsForObj?.["isSomeCanceled"]
          ? selectedRunsForObj?.["dataList"]
          : newDataList;

        existingResult["completedList"] =
          selectedRunsForObj?.["batchID"] === checkData?.["batchID"] &&
          (isSomeCanceled || selectedRunsForObj?.["isSomeCanceled"]) &&
          selectedRunsForObj?.["completedList"]
            ? selectedRunsForObj?.["completedList"]
            : calculateCompleted;
        existingResult["progressStatus"] =
          selectedRunsForObj?.["batchID"] === checkData?.["batchID"] &&
          (isSomeCanceled || selectedRunsForObj?.["isSomeCanceled"])
            ? selectedRunsForObj?.["progressStatus"]
            : progress;

        // Helper function to merge severity arrays
        const mergeSeverity = (existing, newItems) => {
          const shouldMerge = ["ChosenRuns", "on"]?.includes(
            existingResult["selectedRuns"]
          );
          if (!shouldMerge) return newItems;
          return [
            ...new Map(
              [...(existing || []), ...newItems].map((item) => [
                item["checkNumber"] + "|" + item["checkType"],
                item,
              ])
            ).values(),
          ];
        };

        existingResult["reportSeverity"] = mergeSeverity(
          existingResult["reportSeverity"],
          existingCalculateReportSeverity
        );
        existingResult["criticalSeverity"] = mergeSeverity(
          existingResult["criticalSeverity"],
          existingCalculateCriticalSeverity
        );
        existingResult["stopSeverity"] = mergeSeverity(
          existingResult["stopSeverity"],
          existingCalculateStopSeverity
        );
        existingResult["isSomeCanceled"] =
          isSomeCanceled ||
          existingResult?.["isSomeCanceled"] ||
          selectedRunsForObj?.["isSomeCanceled"];
        existingResult["notProperStatus"] =
          selectedRunsForObj?.["notProperStatus"] || notProperStatus;
        existingResult["isCriticalOrStop"] = selectedRunsForObj?.[
          "isCriticalOrStop"
        ]
          ? selectedRunsForObj?.["isCriticalOrStop"]
          : isCriticalOrStop;

        if (
          !!selectedRunsForObj?.["localEndTime"] &&
          calculateCompleted?.length === dataList?.length &&
          !isSomeCanceled
        ) {
          existingResult["localEndTime"] = selectedRunsForObj?.["localEndTime"];
        }

        if (
          !!selectedRunsForObj?.["processValue"]?.length &&
          !!selectedRunsForObj?.["gushValue"]?.length
        ) {
          existingResult["processValue"] = selectedRunsForObj["processValue"];
          existingResult["gushValue"] = selectedRunsForObj["gushValue"];
        }

        finalData[findIndex] = existingResult;
      } else {
        const payload = {
          batchID: checkData?.["batchID"],
          checkType: checkData?.["checkType"],
          batchName: checkData?.["batchName"],
          dataList: selectedRunsForObj?.["isSomeCanceled"]
            ? selectedRunsForObj?.["dataList"]
            : dataList,
          completedList: selectedRunsForObj?.["isSomeCanceled"]
            ? selectedRunsForObj?.["completedList"]
            : calculateCompleted,
          progressStatus: selectedRunsForObj?.["isSomeCanceled"]
            ? selectedRunsForObj?.["progressStatus"]
            : progress,
          isLastProcessEnd: progress === 100 ? true : false,
          reportSeverity: calculateReportSeverity,
          criticalSeverity: calculateCriticalSeverity,
          stopSeverity: calculateStopSeverity,
          isSomeCanceled:
            isSomeCanceled || selectedRunsForObj?.["isSomeCanceled"],
          notProperStatus:
            selectedRunsForObj?.["notProperStatus"] || notProperStatus,
          selectedRuns: selectedRunsForObj?.["selectedRuns"] ?? selectedRuns,
          localStartTime: !!selectedRunsForObj?.["localStartTime"]
            ? selectedRunsForObj?.["localStartTime"]
            : date,
          uploadProgress:
            selectedRunsForObj?.["uploadProgress"] ?? this.state.uploadProgress,
          isCriticalOrStop: selectedRunsForObj?.["isCriticalOrStop"]
            ? selectedRunsForObj?.["isCriticalOrStop"]
            : isCriticalOrStop,
          fileName: selectedRunsForObj?.["fileName"] ?? fileName,
          ...(!!selectedRunsForObj?.["localEndTime"] && {
            localEndTime: selectedRunsForObj?.["localEndTime"],
          }),
          ...(!!selectedRunsForObj?.["processValue"]?.length &&
            !!selectedRunsForObj?.["gushValue"]?.length && {
              processValue: selectedRunsForObj["processValue"],
              gushValue: selectedRunsForObj["gushValue"],
            }),
        };

        finalData = [...finalData, payload];
      }
    }

    this.setState({
      processes: finalData,
    });

    const lastObject = finalData[0];

    const pendingOrInProgressProcesses = lastObject?.["dataList"]?.filter(
      (list) =>
        list?.["status"] === "Pending" || list?.["status"] === "InProgress"
    );

    if (pendingOrInProgressProcesses?.length > 0 && !processIsCanceled) {
      this.props.isProcesssInQueue(true);
      this.setState({ isFileSelected: false });
    }

    if (!loading) {
      if (this.props.isDisabled) {
        if (processIsCanceled || lastObject?.["isSomeCanceled"]) {
          this.props.isProcesssInQueue(false);
          this.setState({ isFileSelected: true });
        }
        if (
          // pendingProcessesState?.length === finalData?.length &&
          pendingOrInProgressProcesses?.length === 0 &&
          lastObject?.["completedList"]?.length > 0 &&
          lastObject?.["dataList"]?.length > 0 &&
          lastObject?.["completedList"]?.length ===
            lastObject?.["dataList"]?.length
        ) {
          this.setState({ isFileSelected: true });

          if (lastObject?.["isLastProcessEnd"]) {
            this.props.isProcesssInQueue(false);
            const currentBatchID = lastObject?.["batchID"];
            const filteredData = data?.filter(
              (process) =>
                process?.checkType !== "D4" &&
                process?.batchID === currentBatchID &&
                process?.dwgFileID
            );
            const DWGFileIds = filteredData?.map(
              (process) => process.dwgFileID
            );
            const fileID =
              lastObject?.completedList?.[lastObject.completedList.length - 1]
                ?.fileID;

            if (RunningD4) {
              this.setState({ RunningD4: false });
            }
          }
        }
      }
    }
  };

  connectedToTheSocket() {
    const socket = io(this.props.socketConnectionEndPoint); // Adjust the server URL if necessary
    // const socket = io("ws://localhost:9001/ws/"); // Adjust the server URL if necessary

    if (socket && this.state.browserSessionID) {
      setTimeout(() => {
        socket.emit("join", this.state.browserSessionID?.replace(/['"]+/g, ""));
      }, 10000);
    }

    // Clean up the socket connection on component unmount
    return () => {
      socket.disconnect();
    };
  }

  componentDidMount() {
    let openedFromSideBar = sessionStorage.getItem("CurrentMouseLocation");
    if (openedFromSideBar !== undefined && openedFromSideBar !== null) {
      const timer = setTimeout(() => {
        var content = document.getElementById("Content");
        if (content !== undefined) {
          if (content?.style) {
            content.style.visibility = "visible";
          }
        }
        clearTimeout(timer);
      }, 600);
    } else {
      var content = document.getElementById("Content");
      if (content !== undefined) {
        if (content?.style) {
          content.style.visibility = "visible";
        }
      }
    }
    this.setState({ processName: this.props?.extraParams?.elipseNumber });

    this.fetchQueueItems(); // Initial fetch when component mounts
    this.fetchCheckLists();
    // Set up an interval to fetch queue items every second
    this.intervalID = setInterval(this.fetchQueueItems, 1000);
    setTimeout(() => {
      this.connectedToTheSocket();
    }, 1500);
  }

  componentDidUpdate(_, prevState) {
    const { processes, registrationNumber, existFileGUID } = this.state;
    const lastObject = processes[0];
    const processContext = this.context;

    if (
      lastObject?.["isSomeCanceled"] &&
      prevState?.processes[0]?.["isSomeCanceled"] !==
        lastObject?.["isSomeCanceled"]
    ) {
      const calculateCompleted = getCalculatedCompleted(
        lastObject?.["dataList"],
        "Processed",
        lastObject?.["batchID"]
      );

      const existingSelectedRunsFor = processContext.processBackUp;
      const findIndexSelectedFor = existingSelectedRunsFor?.findIndex(
        (selectedRun) => selectedRun?.["batchID"] === lastObject?.["batchID"]
      );

      const existingSelectedRunsObj =
        existingSelectedRunsFor?.[findIndexSelectedFor];

      existingSelectedRunsObj["isSomeCanceled"] =
        lastObject?.["isSomeCanceled"];
      existingSelectedRunsObj["completedList"] = calculateCompleted;
      existingSelectedRunsObj["progressStatus"] =
        lastObject?.["progressStatus"];

      processContext.setProcessBackUp([...existingSelectedRunsFor]);
    }
    if (
      !lastObject?.["isSomeCanceled"] &&
      !!lastObject?.["processValue"]?.length &&
      registrationNumber !== lastObject?.["processValue"] &&
      lastObject?.["dataList"]?.length !== lastObject?.["completedList"]?.length
    ) {
      this.setState({
        registrationNumber: lastObject?.["processValue"],
      });
    } else if (
      !!lastObject?.["processValue"]?.length &&
      registrationNumber === lastObject?.["processValue"] &&
      lastObject?.["dataList"]?.length === lastObject?.["completedList"]?.length
    ) {
      this.setState({
        registrationNumber: "",
      });
    }
  }

  componentWillUnmount() {
    // Clear the interval to prevent memory leaks
    clearInterval(this.intervalID);
  }

  closingAllqueueRequest = async () => {
    const { browserSessionID, processes } = this.state; // Retrieve the session ID from state
    const lastObject = processes?.[0];
    const processContext = this.context;

    const sessionId = browserSessionID.replace(/['"]+/g, "");
    const resp = await cancelQueueProcessCancel(
      this.generalEndPoint,
      sessionId
    );

    if (resp?.status === 200) {
      this.setState({
        ...this.state,
        isProcessCancelModal: false,
        browserSessionID: "",
      });
      this.props.isProcesssInQueue(false);
      this.setState({
        processIsCanceled: true,
      });

      const calculateCompleted = getCalculatedCompleted(
        lastObject?.["dataList"],
        "Processed",
        lastObject?.["batchID"]
      );

      const dataList = lastObject?.["dataList"]?.map((list) =>
        list?.["status"] === "Pending" || list?.["status"] === "InProgress"
          ? {
              ...list,
              status: "Canceled",
            }
          : list
      );

      const existingSelectedRunsFor = processContext.processBackUp;
      const findIndexSelectedFor = existingSelectedRunsFor?.findIndex(
        (selectedRun) => selectedRun?.["batchID"] === lastObject?.["batchID"]
      );

      const existingSelectedRunsObj =
        existingSelectedRunsFor?.[findIndexSelectedFor];

      existingSelectedRunsObj["isSomeCanceled"] = true;
      existingSelectedRunsObj["completedList"] = calculateCompleted;
      existingSelectedRunsObj["dataList"] = dataList;
      existingSelectedRunsObj["progressStatus"] =
        lastObject?.["progressStatus"];

      processContext.setProcessBackUp([...existingSelectedRunsFor]);
      this.setState({
        registrationNumber: "",
      });
    }
  };
  render() {
    const {
      processes,
      selectedRuns,
      D2_checksList,
      D3_checksList,
      D3_cmp,
      D3_advanced,
      RunningD4,
      loading,
      selectedD2Checks,
      selectedD3Checks,
      registrationNumber,
    } = this.state;
    const { isDisabled } = this.props;
    const landRegistryPic = loadImage("LandRegister.svg");
    const loadingIcon = loadImage("loading_continuous.gif");
    let sidebarClicked = sessionStorage.getItem("CurrentMouseLocation");
    let workAreaClassMame = sidebarClicked
      ? "workAreaPageAnimation main-wrap-loader"
      : "workAreaPage";

    return (
      <>
        <SideMenuContext.Consumer>
          {({ setSelectedMenu, isSelectedMenu }) => (
            <div className={workAreaClassMame}>
              <div id="TamarTitleDiv">
                {/* <p className="Tamar_Title">קליטת תמ"ר לבדיקות</p> */}
                <p className="Tamar_Title">
                  {/* ביצוע בדיקות וטעינת תמ"ר  */}
                  {isSelectedMenu?.["title"]}
                </p>
                <div id="Content">
                  <SearchTamarForm
                    ref={this.searchTamarFormRef} // Pass the reference to the form
                    id="SearchTamarForm"
                    project_no=""
                    project_name=""
                    dwg=""
                    D2_checksList={D2_checksList}
                    D3_checksList={D3_checksList}
                    D3_cmp={D3_cmp}
                    D3_advanced={D3_advanced}
                    selectedD2Checks={selectedD2Checks}
                    selectedD3Checks={selectedD3Checks}
                    isDataInProcess={this.allQueuesItemProcessed}
                    isDisabled={isDisabled}
                    processes={processes}
                    selectedRuns={selectedRuns}
                    setSelectedRuns={this.setSelectedRuns}
                    handleUploadProgress={this.handleUploadProgress}
                    handleOnChange={this.handleOnChange}
                    addInFirstObj={this.addInFirstObj}
                    setLoading={this.setLoading}
                    loading={loading}
                    setRunningD4={this.setRunningD4}
                    setFileName={this.setFileName}
                    registrationNumber={registrationNumber}
                    existFileGUID={this.state.existFileGUID}
                    setExistFileGUID={this.setExistFileGUID}
                    processName={this.state.processName}
                    gushNumber={this.state.gushNumber}
                    generalEndPoint={this.generalEndPoint}
                    extraParams={this.props.extraParams}
                  />
                </div>
                {/* processes cards for the proccessing */}
                <div className="resultsProjectCards">
                  <div className="processCards">
                    {processes
                      ?.filter(
                        (process) =>
                          process?.checkType !== "D4" &&
                          process.dataList[0].checkNumber !==
                            "validateProcessName"
                      )
                      .map((process, ind) => {
                        const blink =
                          process?.["completedList"]?.length === 0 ||
                          (process?.["completedList"]?.length === 1 &&
                            this.getBatchStatus(process?.["batchID"]) ===
                              "Pending");

                        return (
                          <ProcessCard
                            {...process}
                            isBlinking={
                              blink && !process?.["isSomeCanceled"] && ind === 0
                            }
                            key={process?.["batchID"]}
                            D2_checksList={this.state.D2_checksList}
                            D3_checksList={this.state.D3_checksList}
                            D3_cmp={this.state.D3_cmp}
                            D3_advanced={this.state.D3_advanced}
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="buttons-bottom">
                <div className="button-group">
                  <button
                    className="closeButton"
                    onClick={() => {
                      this.cancelRequestQueueProcess();
                      !this.props.isDisabled && setSelectedMenu({});
                    }}
                  >
                    {this.props.isDisabled ? "בטל" : "סגירה"}
                    {/* סגירה/ביטול */}
                  </button>

                  {RunningD4 ? (
                    <button
                      type="button"
                      className={"continueButton btnDissabled cursor-disabled"}
                      disabled={true}
                    >
                      <div className="fileLoading">
                        <img src={loadingIcon} alt="loading D4" />
                      </div>
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={
                        isActiveToContinue(this.state, this.props)
                          ? "continueButton btnDissabled cursor-disabled"
                          : "continueButton"
                      }
                      onClick={this.handleD4}
                      disabled={isActiveToContinue(this.state, this.props)}
                    >
                      המשך
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        </SideMenuContext.Consumer>
        <ModalComponent
          show={this.state.isProcessCancelModal}
          onHide={() => this.setState({ isProcessCancelModal: false })}
          title=""
          bodyContent={
            <p>?כל הבדיקות שלא הסתיימו יבוטלו. האם אתה בטוח שברצונך להמשיך</p>
          }
          footerContent={
            <>
              <Button
                onClick={() => this.setState({ isProcessCancelModal: false })}
              >
                לא
              </Button>
              <Button onClick={() => this.closingAllqueueRequest()}>כן</Button>
            </>
          }
        />

        <ModalComponent
          show={this.state.RandomError}
          onHide={() => {
            const batchID = this.state.randomErrorPopupBatchID;
            this.setState((prev) => ({
              RandomError: false,
              randomErrorPopupBatchID: null,
              randomErrorDismissedBatchIDs: batchID
                ? [...(prev.randomErrorDismissedBatchIDs || []), batchID]
                : prev.randomErrorDismissedBatchIDs,
            }));
          }}
          title=""
          bodyContent={<p dir="rtl">התרחשה שגיאה, אנא נסה שוב מאוחר יותר.</p>}
          footerContent={
            <>
              <Button
                onClick={() => {
                  const batchID = this.state.randomErrorPopupBatchID;
                  this.setState(
                    (prev) => ({
                      RandomError: false,
                      randomErrorPopupBatchID: null,
                      randomErrorDismissedBatchIDs: batchID
                        ? [...(prev.randomErrorDismissedBatchIDs || []), batchID]
                        : prev.randomErrorDismissedBatchIDs,
                    }),
                    () => this.closingAllqueueRequest()
                  );
                }}
              >
                סגירה
              </Button>
            </>
          }
        />

        <ModalComponent
          show={this.state.isD4ConfirmationModal}
          onHide={() => this.setState({ isD4ConfirmationModal: false })}
          title=""
          bodyContent={
            <p dir="rtl">
              המערכת עומדת לטעון את התמ"ר לבסיס הנתונים. האם ברצונך להמשיך?
              <br />
              שים לב: לא ניתן לעצור את התהליך לאחר תחילתו.
            </p>
          }
          footerContent={
            <>
              <Button
                onClick={() => this.setState({ isD4ConfirmationModal: false })}
              >
                לא
              </Button>
              <Button
                onClick={() => {
                  this.setState({ isD4ConfirmationModal: false });
                  this.confirmAndExecuteD4();
                }}
              >
                כן
              </Button>
            </>
          }
        />

        <ModalComponent
          show={this.state.isCriticalWarningModal}
          onHide={() => this.setState({ isCriticalWarningModal: false })}
          title=""
          bodyContent={
            <p dir="rtl">
              זוהו שגיאות קריטיות. האם ברצונך לטעון את התמ"ר לבסיס הנתונים?
              <br />
              לתשומך ליבך: לא ניתן לעצור את התהליך לאחר תחילתו.
            </p>
          }
          footerContent={
            <>
              <Button
                onClick={() => this.setState({ isCriticalWarningModal: false })}
              >
                לא
              </Button>
              <Button
                onClick={() => {
                  this.setState({ isCriticalWarningModal: false });
                  this.confirmAndExecuteD4();
                }}
              >
                כן
              </Button>
            </>
          }
        />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const landSearch = state.landSearch;

  return {
    projectData: state?.project?.NewProject,
    loading: state?.project?.status,
    error: state?.project?.error,
    clearAllErrors: landSearch.clearAllErrors,
  };
};

export default withRouter(connect(mapStateToProps)(LoadTamar));
